// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"219":"b5c42ac2","230":"58c61b4c","442":"41b9f13d"}[chunkId] + ".chunk.js";
};